<template>
	<b-container id="main-content">
		<h2>Edit Application {{ active_application_id }}</h2>
		<b-form @submit.prevent="on_create_app">
			<b-row>
				<b-form-group label="What type of applicant are you?">
					<b-form-radio-group id="rbnGrpTrad" name="rbnGrpTrad" v-model="trad">
						<b-form-radio
							value="traditional"
							v-b-tooltip.hover
							title="Current high school or college student, or anyone 24 years of age or younger at the time of application."
							v-focus
						>
							Traditional
						</b-form-radio>
						<b-form-radio
							value="nontraditional"
							v-b-tooltip.hover
							title="Anyone over the age of 24 at the time of application."
						>
							Non-Traditional
						</b-form-radio>
					</b-form-radio-group>
				</b-form-group>
			</b-row>

			<b-row>
				<b-form-group label="Are you a first-year or transfer student?">
					<b-form-radio-group id="rbnGrpYear" name="rbnGrpYear" v-model="year">
						<b-form-radio value="firstyear">First Year</b-form-radio>
						<b-form-radio value="transfer">Transfer</b-form-radio>
					</b-form-radio-group>
				</b-form-group>
			</b-row>

			<b-row>
				<b-form-group label="Select one or more campuses to apply to :">
					<b-form-checkbox-group v-model="selectedCampuses" :options="campuses">
					</b-form-checkbox-group>
				</b-form-group>
			</b-row>

			<b-row>
				<b-col>
					<b-btn variant="primary" :disabled="!form_is_valid" type="submit"
						>Continue</b-btn
					>
				</b-col>
				<b-col>
					<b-btn
						class="float-right"
						variant="secondary"
						size="sm"
						@click.prevent="cancel_action()"
					>
						Cancel
					</b-btn>
				</b-col>
			</b-row>
		</b-form>
	</b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			trad: "",
			year: "",
			selectedCampuses: []
		};
	},
	computed: {
		...mapGetters(["campuses", "active_application", "active_application_id"]),
		form_is_valid() {
			return (
				this.selectedCampuses.length > 0 && this.trad !== "" && this.year !== ""
			);
		}
	},
	methods: {
		on_create_app() {
			this.$store.dispatch("edit_application", {
				app_id: this.active_application_id,
				trad: this.trad,
				year: this.year,
				campuses: this.selectedCampuses
			});
		},
		cancel_action() {
			this.$router.push("/applications");
		}
	},
	created() {
		this.year = this.active_application.studentType;
		this.trad = this.active_application.applicantType;
		this.selectedCampuses = this.active_application.campuses;
	},
	watch: {
		active_application_id(value) {
			if (!value) {
				this.$router.push("/applications");
			}
		}
	}
};
</script>

<style scoped></style>
